import { Box, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/hooks';
import { showSideMenu } from '@/store/actions';
import { getShowSideMenu, getUserLoaded } from '@/store/selectors';
import { getNewReports } from '@/store/thunks';
import { theme } from '@/theme';

import { AuthUserGuard } from '../guards/NotAuthorized';
import { Header, SideMenu } from './components';
import { ContentBox, Main, SideMenuHeader } from './styled';

export const DashboardLayout = () => {
  const dispatch = useAppDispatch();
  const openSideMenu = useAppSelector(getShowSideMenu);
  const isUserLoaded = useAppSelector(getUserLoaded);
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    dispatch(getNewReports());
  }, [dispatch]);

  useEffect(() => {
    if (isMobileScreen) {
      dispatch(showSideMenu(false));
    } else {
      dispatch(showSideMenu(true));
    }
  }, [dispatch, isMobileScreen]);

  return (
    <Box display="flex">
      <Header isSideMenuOpen={openSideMenu} />
      <SideMenu isOpen={openSideMenu} />
      {isUserLoaded ? <AuthUserGuard /> : null}

      <Main open={openSideMenu} isMobile={isMobileScreen}>
        <SideMenuHeader />
        <ContentBox>
          <Outlet />
        </ContentBox>
      </Main>
    </Box>
  );
};
